var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 237,
    viewBox: "0 0 251 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5,
    x2: 4.5,
    y2: 61.0078,
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4.00391,
    x2: 60.745,
    y2: 4.00391,
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -4,
    x2: 60.0071,
    y2: -4,
    transform: "matrix(0 1 1 0 249.5 1)",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -4,
    x2: 59.745,
    y2: -4,
    transform: "matrix(-1 0 0 1 249 8.00391)",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -4,
    x2: 60.0078,
    y2: -4,
    transform: "matrix(0 -1 -1 -9.31209e-10 0.5 233.008)",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -4,
    x2: 59.745,
    y2: -4,
    transform: "matrix(1 0 0 -1 1 226.004)",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 246.5,
    y1: 231.008,
    x2: 246.5,
    y2: 175.001,
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 232.004,
    x2: 190.255,
    y2: 232.004,
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBold);
export default __webpack_public_path__ + "static/media/scan-bold.742db0311b3a3ca9ce3989421a4abdcd.svg";
export { ForwardRef as ReactComponent };